/*
 * Module for listing the examples in the quick create example editor
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/quickCreate/quickExampleModal/quickExamplesList/quickExamplesListView",
], function (Marionette, Messenger, QuickExamplesListView) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "quickExamplesList";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (examplesCollection) {
      this.view = new QuickExamplesListView.quickExamplesListView({
        collection: examplesCollection,
      });
      this.failureThreshold = Messenger.reqres.request("example:failure:threshold");

      //add new example
      this.view.on(
        "add:example",
        function () {
          this.validateExampleBefore(null, function () {
            const example = examplesCollection.addExample();
            this._selectExample(example);
          });
        },
        this,
      );

      //edit example
      this.view.on(
        "itemview:edit:example",
        function (exampleView) {
          const example = exampleView.model;
          this.validateExampleBefore(example, function () {
            this._selectExample(example);
          });
        },
        this,
      );

      //create an array to store examples that should be deleted if the user hits done (and doesn't cancel out)
      this.pendingDeletions = [];
      //delete an example
      this.view.on(
        "itemview:delete:example",
        function (exampleView) {
          //add example model to the pending deletions array and remove the example from the collection (locally only)
          this.pendingDeletions.push(exampleView.model);
          //deselect if selected
          let deletedSelectedExample = false;
          if (this.selectedExample === exampleView.model) {
            deletedSelectedExample = true;
            const selectedView = this.view.children.findByModel(this.selectedExample);
            selectedView.deselect();
            delete this.selectedExample;
          }
          examplesCollection.remove(exampleView.model);
          //if we deleted a selected example, select the first example from the list
          if (deletedSelectedExample) {
            this._selectFirstExample(examplesCollection);
          }
        },
        this,
      );

      //when shown, select the first item from the list, or create a new example if one didn't exist
      this.view.on(
        "show",
        function () {
          examplesCollection.onSynced(function () {
            this._selectFirstExample(examplesCollection);
          }, this);
        },
        this,
      );

      this.showRegion(this.view, { loading: true });
    },
    finalizeDeletions: function () {
      //send deletion requests for all the examples in the pendingDeletions array
      const pendingDeletionsLength = this.pendingDeletions.length;
      for (let i = 0; i < pendingDeletionsLength; i++) {
        this.pendingDeletions[i].deleteModel();
      }
    },
    markAsFailure: function () {
      if (this.selectedExample) {
        //mark the example as a failure using a red exclamation point
        const exampleView = this.view.children.findByModel(this.selectedExample);
        if (exampleView) exampleView.markAsFailure();
      }
    },
    unmarkAsFailure: function () {
      if (this.selectedExample && this.selectedExample.failure) {
        //unmark the example
        const exampleView = this.view.children.findByModel(this.selectedExample);
        if (exampleView) exampleView.unmarkAsFailure();
      }
    },
    //used to make sure we can leave the selected example before we do something else (the callback function)
    validateExampleBefore: function (example, callback) {
      //if we are switching from another example
      if (this.selectedExample) {
        //if the new example is the same as the old one, just return
        if (this.selectedExample === example) return;
        //if the current example is not new and is not dirty, don't even bother validating and just deselect and trigger callback
        if (!this.selectedExample.entries().dirty && !this.selectedExample.isNew()) {
          //deselect the current example
          const selectedView = this.view.children.findByModel(this.selectedExample);
          selectedView.deselect();
          this.selectedExample.entries().off("change", null, this);
          //trigger callback
          callback.apply(this);
          return;
        }
        Messenger.vent.trigger("update:strength", this.selectedExample.entries(), {
          callback: callback,
          closing: true,
        });
      } else {
        callback.apply(this);
      }
    },
    _selectExample: function (example) {
      //selects the example
      const exampleView = this.view.children.findByModel(example);
      exampleView.select();
      this.selectedExample = example;
      //let the other modules know that an example has been selected
      Messenger.vent.trigger("example:selected", example);
    },
    _selectFirstExample: function (examplesCollection) {
      this.validateExampleBefore(null, function () {
        if (examplesCollection.length === 0) {
          examplesCollection.addExample();
        }
        const example = examplesCollection.at(0);
        this._selectExample(example);
      });
    },
    _setUpVents: function () {
      //need to check strength before switching
      Messenger.vent.on(
        "strength:updated",
        function (strength, options) {
          if (options && options.closing) {
            if (strength > this.failureThreshold) {
              //apply sub group defaults and wait until synced
              this.selectedExample.applyDefaults();
              this.selectedExample.once(
                "sync",
                function () {
                  //clean up entries
                  this.selectedExample.entries().prepareToSave();
                  //deselect the current example
                  var selectedView = this.view.children.findByModel(this.selectedExample);
                  selectedView.deselect();
                  this.unmarkAsFailure();
                  this.selectedExample.entries().off("change", null, this);
                  //trigger callback
                  options.callback.apply(this);
                },
                this,
              );
            } else {
              this.markAsFailure();
            }
          }
        },
        this,
      );
    },
  });
});
